export default "__VITE_ASSET__s63J7y9t__"